import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  notifications: [],
  oldNotifications: [],
  notificationsCount: 0,
  oldNotificationsCount: 0
};

export default {
  state,
  actions,
  mutations,
  getters
};
